import { skipToken } from '@reduxjs/toolkit/query'

import { StageTimingsView, platformSearchTimingOf, platformSearchTimingSummary } from '@krp/platform-ui'

import { toTimingsLoad } from './searchTimingsLoad'

/**
 * Время поиска по этапам внутри «Посмотреть детали поиска»: время этого поиска (по номеру из ответа) и сводка за 7 дней. Монтируется только
 * когда администратор раскрыл детали, поэтому запросы уходят по требованию, а не при каждом поиске.
 */
export function SearchTimingsBinding({ searchId }: { searchId: string | null }) {
  const current = platformSearchTimingOf.useQuery(searchId ?? skipToken)
  const summary = platformSearchTimingSummary.useQuery()
  return <StageTimingsView current={searchId === null ? null : toTimingsLoad(current)} summary={toTimingsLoad(summary)} />
}
